import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=b1c62802&scoped=true"
import script from "./TemplateForm.vue?vue&type=script&lang=js"
export * from "./TemplateForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateForm.vue?vue&type=style&index=0&id=b1c62802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c62802",
  null
  
)

export default component.exports